import React from "react";
import { Button } from "semantic-ui-react";
import "./ResultsSlide.scss";

// Puedes usar una librería como 'react-circular-progressbar' para el gráfico, pero aquí va una versión SVG simple
const getPercentage = (correct, incorrect, unanswered) => {
  const total = correct + incorrect + unanswered;
  if (!total) return 0;
  return Math.round((correct / total) * 100);
};

const getScoreColor = (score) => {
  if (score >= 10) return "#4fd18b"; // verde
  if (score >= 7) return "#f7c873"; // amarillo
  return "#ff6b6b"; // rojo
};

export const ResultsSlide = (props) => {
  const { results, onOpenCloseConfirm, view } = props;
  const percent = getPercentage(
    results?.correctAnswers || 0,
    results?.incorrectAnswers || 0,
    results?.unanswered || 0
  );
  const scoreColor = getScoreColor(results?.score || 0);
  return (
    <div className="results-slide">
      <div className="results-card no-bg">
        <div className="results-score-circle">
          <svg width="260" height="260" viewBox="0 0 180 180">
            {/* Anillo correctas (más externo) */}
            <circle
              cx="90"
              cy="90"
              r="75"
              fill="none"
              stroke="#4fd18b"
              strokeWidth="10"
              strokeDasharray={`${Math.PI * 2 * 75}`}
              strokeDashoffset={`${Math.PI * 2 * 75 * (1 - (results?.correctAnswers || 0) / (results?.correctAnswers + results?.incorrectAnswers + results?.unanswered || 1))}`}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 0.7s", transform: "rotate(-90deg)", transformOrigin: "50% 50%" }}
            />
            {/* Anillo incorrectas (medio) */}
            <circle
              cx="90"
              cy="90"
              r="60"
              fill="none"
              stroke="#ff6b6b"
              strokeWidth="10"
              strokeDasharray={`${Math.PI * 2 * 60}`}
              strokeDashoffset={`${Math.PI * 2 * 60 * (1 - (results?.incorrectAnswers || 0) / (results?.correctAnswers + results?.incorrectAnswers + results?.unanswered || 1))}`}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 0.7s", transform: "rotate(-90deg)", transformOrigin: "50% 50%" }}
            />
            {/* Anillo no respondidas (más interno) */}
            <circle
              cx="90"
              cy="90"
              r="45"
              fill="none"
              stroke="#f7c873"
              strokeWidth="10"
              strokeDasharray={`${Math.PI * 2 * 45}`}
              strokeDashoffset={`${Math.PI * 2 * 45 * (1 - (results?.unanswered || 0) / (results?.correctAnswers + results?.incorrectAnswers + results?.unanswered || 1))}`}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 0.7s", transform: "rotate(-90deg)", transformOrigin: "50% 50%" }}
            />
            {/* Nota al centro */}
            <text
              x="90"
              y="98"
              textAnchor="middle"
              fontSize="4rem"
              fontWeight="bold"
              fill={scoreColor}
              alignmentBaseline="middle"
              dominantBaseline="middle"
            >
              {results?.score}
            </text>
          </svg>
        </div>
        <div className="results-feedback" style={{ color: scoreColor }}>
          {results?.score >= 10
            ? "¡Muy bien!"
            : results?.score >= 7
            ? "Puedes mejorar"
            : "Necesitas repasar"}
        </div>
        <div className="results-legend-card">
          <div className="results-legend vertical">
            <div>
              <span className="dot correct"></span> Correctas: {results?.correctAnswers}
            </div>
            <div>
              <span className="dot incorrect"></span> Incorrectas: {results?.incorrectAnswers}
            </div>
            <div>
              <span className="dot unanswered"></span> No respondidas: {results?.unanswered}
            </div>
          </div>
        </div>
        <div className="results-attempt">Intento {results?.attempts} de 3</div>
        {view !== "academyHistory" && (
          <Button
            className="btn btn-primary"
            onClick={onOpenCloseConfirm}
            icon="redo"
            size="large"
          >
            Reintentar
          </Button>
        )}
      </div>
    </div>
  );
};
